import { Injectable } from '@angular/core';
import type { CompanyFindResultInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company.find.result.dto';
import type { PersonFormInterface } from '@zaoblako/shared/modules/client/dtos/person/person-form.dto';
import type { PersonFindQueryBaseInterface } from '@zaoblako/shared/modules/client/dtos/person/base/person.find.query.base.dto';
import type { PersonExternalSearchQueryInterface } from '@zaoblako/shared/modules/client/dtos/person/person.external.search.query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseService {
  protected baseUrl = '/client/company';

  public getAll(queryParams: PersonFindQueryBaseInterface): Observable<CompanyFindResultInterface> {
    return this.http.get<CompanyFindResultInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public externalSearch(queryParams: PersonExternalSearchQueryInterface): Observable<PersonFormInterface[]> {
    return this.http.get<PersonFormInterface[]>('/client/external-search', {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
